module.exports = __webpack_public_path__ + "img/yield.8bf339b2.svg";